import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {
  find,
  get,
  toNumber,
  uniqueId,
} from 'lodash';
import {
  API,
  Field2 as Field,
  GlobalActions,
  SidePanelContainer,
  SidePanelSection,
  SidePanelContent,
  TableLocationZoneManagement,
} from 'vibeguide';

function ImportZones({
  bannerId,
  bannerName,
  companyId,
  mediaFormat,
  style,
  className,
  user,
  // onClose,
}) {
  const [tableLocationZones, setTableLocationZones] = useState([]);
  const [banner, setBanner] = useState({});

  /**
     * Get the banner details
     * Also fetch the global list of location zones that can be applied to the banner
     * Data is merged from the assigned location zones on the banner with the global list of zones
  */
  useEffect(async () => {
    if (user.can('location-zone.view')) {
      const allLocationZones = await API.LocationZones.list({
        pageSize: -1,
      });

      const locationZonesList = get(allLocationZones, 'data', []) || [];

      setTableLocationZones(locationZonesList.map(locationZone => {
        return {
          // local collections need a row ID before hitting the table for row selection to work properly
          _rowId: uniqueId(`${locationZone._id}-`),
          ...locationZone,
          active: false,
        };
      }));
    }

    if (bannerId) {
      const response = await API.Company.Banner.get({
        _id: bannerId,
        companyId,
      });

      setBanner({
        ...response,
        locationZones: (get(response, 'locationZones', []) || []).map(zone => {
          return {
            ...zone,
            // Round down so results don't come up as 14.000000002
            audioMultiplier: Math.floor((toNumber(zone.audioMultiplier) * 100)) || 0,
            visualMultiplier: Math.floor((toNumber(zone.visualMultiplier) * 100)) || 0,
          };
        }),
      });
    }

    // setReady(true);
  }, []);

  /**
   * When banner location zone data is changed, re-render the zone assignment table
   */
  useEffect(() => {
    setTableLocationZones(tableLocationZones.map(locationZone => {
      // check if the banner has this location zone assigned
      const bannerLocationZone = find(banner.locationZones, { _id: locationZone._id });

      // use the banner location zone with multiplier information if it is assigned
      if (bannerLocationZone) {
        return {
          ...bannerLocationZone,
          ...locationZone,
          active: true,
        };
      }

      return locationZone;
    }));
  }, [banner.locationZones]);

  return (
    <SidePanelContainer
      className={classNames('CompanyBannerEdit', className)}
      style={style}
    >
      <SidePanelContent
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 0,
        }}
      >
        <SidePanelSection
          title="Banner Information"
          style={{
            padding: 24,
            paddingBottom: 0,
          }}
        >
          <Field
            style={{
              width: 320,
            }}
            type="text"
            label="Banner"
            placeholder="Banner"
            name="name"
            value={bannerName}
            disabled
            required
            autoFocus
          />
        </SidePanelSection>

        {user.can('location-zone.view') && (
          <SidePanelSection
            title="Zone Assignments"
            titleStyle={{
              padding: '0 24px',
            }}
            style={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              marginBottom: 0,
            }}
          >
            <TableLocationZoneManagement
              columns={[
                'Zone',
                'ID',
                'Audio Impression Multiplier',
                'Visual Impression Multiplier',
                '...',
              ]}
              available
              collection={tableLocationZones}
              defaultSortBy={{
                label: 'Zone',
                attr: 'name',
                direction: 'asc',
              }}
              paginator
              paginatorProps={{
                label: 'Zones',
                urlPaging: false,
                urlFilters: false,
              }}
              editMode
              importZones
              mediaFormat={mediaFormat}
              // disableSelect={disableInput}
              // editMode={!disableInput}
              // onChangeSelected={onChangeSelectedZones}
              // onChange={onChangeRowData}
            />
          </SidePanelSection>
        )}
      </SidePanelContent>
    </SidePanelContainer>
  );
}

ImportZones.propTypes = {
  // companyId: PropTypes.string,
  // onClose: PropTypes.func,
};

ImportZones.defaultProps = {
  // companyId: '',
  // onClose: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportZones);
